export const Reg = {
  intPositve: /^\d+$/,
  intNeg: /^-\d+$/,
  int: /^-?\d+$/,
};
